import helpers from '../../../helpers'

// Campos del alta que se validan, en el orden del formulario.
export const FIELDS = ['lastName', 'firstName', 'addressLine1', 'city', 'zipCode', 'email', 'phone', 'cbu']

const compact = value => String(value || '').replace(/\s/g, '')
const hasDigits = value => /\d/.test(value)
// Teléfono: sólo números (se toleran espacios, guiones, paréntesis y un + inicial), código de
// área + número sin 0 ni 15 → 10 dígitos, como pide la ayuda del campo. Antes contaba los
// dígitos y dejaba pasar letras ("11abc4567xyz"). El prefijo internacional (+54 o +54 9) se
// acepta y no cuenta: "+54 9 11 5555-0123" es el mismo número (review 02/11).
const nationalDigits = value => {
  const digits = value.replace(/\D/g, '')
  if (/^549\d{10}$/.test(digits)) return digits.slice(3)
  if (/^54\d{10}$/.test(digits)) return digits.slice(2)
  return digits
}
const isPhone = value => /^\+?[\d\s()-]+$/.test(value) && /^[1-9]\d{9}$/.test(nationalDigits(value))
// Lo que se manda a Increase (billing_info.phone): los 10 dígitos, sin prefijo ni separadores
// (review de drmanager#389, 03/11). Un valor que no pasa la validación queda como está.
export const normalizePhone = value => {
  const trimmed = String(value || '').trim()
  return isPhone(trimmed) ? nationalDigits(trimmed) : value
}
const isCBU = value => /^[\d\s-]+$/.test(value) && value.replace(/\D/g, '').length === 22

// Mensaje de error por campo (sólo los que están mal). `t` es el de react-i18next.
export function validateSubscription(subscription, t) {
  const {
    email = '',
    lastName = '',
    firstName = '',
    addressLine1 = '',
    zipCode = '',
    phone = '',
    city = '',
    paymentMethod = 'card',
    cbu = '',
  } = subscription
  const warnings = {}

  if (!helpers.isEmail(email.trim())) warnings.email = t('subscriptions_form_invalid_email', 'Ingrese un email valido')
  if (compact(lastName).length <= 2 || hasDigits(lastName)) warnings.lastName = t('subscriptions_form_invalid_last_name', 'Ingrese un apellido valido')
  if (compact(firstName).length <= 2 || hasDigits(firstName)) warnings.firstName = t('subscriptions_form_invalid_first_name', 'Ingrese un nombre valido')
  if (compact(addressLine1).length < 6) warnings.addressLine1 = t('subscriptions_form_invalid_address_line1', 'Ingrese una direccion valida')
  if (compact(city).length < 4 || hasDigits(city)) warnings.city = t('subscriptions_form_invalid_city', 'Ingrese una ciudad valida')
  if (!isPhone(phone.trim())) warnings.phone = t('subscriptions_form_invalid_phone_number', 'Ingrese un numero de telefono valid. Codigo de area + numero de telefono. Sin el cero ni el 15')
  // Admite el CPA (C1425ABC): sólo se exige un mínimo de dígitos.
  if (zipCode.replace(/\D/g, '').length < 4) warnings.zipCode = t('subscriptions_form_invalid_zip_code', 'Ingrese un codigo postal valido')
  if (paymentMethod === 'cbu' && !isCBU(cbu.trim())) warnings.cbu = t('subscriptions_form_invalid_cbu', 'EL CBU debe tener 22 digitos')

  return warnings
}
